define(function(require, exports, module) {
    'use strict';

    var BingoPromocodeView = require('replacers/bingo-promocode/bingo.promocode.view');

    module.exports = BingoPromocodeView.extend({

        _handleSuccessResponse: function(response) {
            var message;
            var status = 'success';

            if (response.data && response.data.result) {
                message = this.successIMSmessages[response.data.result - 1];
                status = response.data.result === 3 ? 'error' : status;
            } else {
                message = response.data && response.data.message ? response.data.message : this.successVFmessages[0];
            }

            this._openPopup(message, status);
        },

        _handleErrorResponse: function() {
            this._openPopup('playtech.mobile.system.promocode.error', 'error');
        },

        _openPopup: function(message, status) {
            window.Playtech.API.popup.showPopup({
                className: `promocode-popup ${status}`,
                title: this.translate(message),
                content: this.translate(`playtech.mobile.system.promocode.${status}.description`),
                acceptBtnText: this.translate(message)
            });

        }
    }, {
        nameOfReplacers: [
            'BINGO_PROMOCODE'
        ]
    });
});
